import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';

import { ActivePaymentMethod } from 'containers';
import { Content } from 'components/Common';
import { Header, UpdatePaymentMethod } from 'components';

export const PaymentMethod = ({ t, match }) => {
  return (
    <div>
      <Header
        title={t('paymentMethod.title')}
        description={t('paymentMethod.description')}
      />

      <Content>
        <Switch>
          <Route path={`${match.url}/update`} component={UpdatePaymentMethod} />
          <Route path={match.url} component={ActivePaymentMethod} />
          <Route render={() => <Redirect to={match.url} />} />
        </Switch>
      </Content>
    </div>
  );
};

PaymentMethod.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
};

export default translate()(PaymentMethod);



// WEBPACK FOOTER //
// ./src/components/PaymentMethod/PaymentMethod.js